import { boundsToQuery, _isBoundOverlappingBound } from "../quadtree/bounds";
export class ListStorage {
    constructor() {
        this.data = [];
    }
    setData(data) {
        this.data = data;
    }
    addData(data) {
        if (data instanceof Array) {
            this.data.push(...data);
        }
        else {
            this.data.push(data);
        }
    }
    getData(bounds) {
        return this.data.filter((item) => _isBoundOverlappingBound(item, boundsToQuery(bounds)));
    }
}
